﻿import React from 'react';
import {connect} from 'react-redux';

import {GuideFormBase, connectForm} from './GuideFormBase';
import Checkbox from '../../../Forms/Components/Checkbox';
import RadioButton from '../../../Forms/Components/RadioButton';

import definitions from '../../../Style/LfStyleDefinitions';
import {required} from '../../../Forms/Validation/rules';

class Step5Form extends GuideFormBase {
    render() {
        const StepForm = this.stepFormWrapper;

        return (
            <StepForm heading="Hur ser din boendesituation ut?">
                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="livingSituation__rental"
                    name="livingSituation" 
                    value="rental"
                    displayname="Hyresrätt"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.livingSituation === 'rental'}
                />

                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="livingSituation__cooperative"
                    name="livingSituation" 
                    value="cooperative"
                    displayname="Bostadsrätt"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.livingSituation === 'cooperative'}
                />

                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="livingSituation__house"
                    name="livingSituation" 
                    value="house"
                    displayname="Radhus/Villa"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.livingSituation === 'house'}
                />

                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="livingSituation__privaterental"
                    name="livingSituation" 
                    value="privaterental"
                    displayname="Hyr i andra hand"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.livingSituation === 'privaterental'}
                />

                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="livingSituation__studentdorm"
                    name="livingSituation" 
                    value="studentdorm"
                    displayname="Studentrum"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.livingSituation === 'studentdorm'}
                />

                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="livingSituation__exile"
                    name="livingSituation" 
                    value="exile"
                    displayname="Bor utomlands"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.livingSituation === 'exile'}
                />

                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="livingSituation__withparents"
                    name="livingSituation" 
                    value="withparents"
                    displayname="Bor med föräldrar"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.livingSituation === 'withparents'}
                />

                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="livingSituation__livingapart"
                    name="livingSituation" 
                    value="livingapart"
                    displayname="Särbo"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.livingSituation === 'livingapart'}
                />
            </StepForm>
        );
    }
}

export default connectForm({ formClass: Step5Form, guideStep: 5 });